// mui
import { Box, Grid, Typography } from '@mui/material';
import { ReactNode } from 'react';

// props
export interface LegendItemProps {
	label: ReactNode;
	value: ReactNode;
}
export interface LegendProps {
	items?: LegendItemProps[];
}

export const Legend = ({ items = [] }: LegendProps) => {
	if (!items.length) {
		return <></>;
	}

	return (
		<Grid container>
			{items.map((item, index) => {
				const { label, value } = item;
				return (
					<Grid item xs={12}>
						<Box
							sx={(theme) => {
								return {
									padding: theme.spacing(2),
									borderBottomColor: theme.palette.divider,
									borderBottomStyle: 'solid',
									borderBottomWidth: index < items.length - 1 ? 1 : 0,
								};
							}}>
							<Grid container spacing={1}>
								<Grid item xs={12}>
									{label}
								</Grid>
								<Grid item xs={12}>
									{typeof value === 'string' ? (
										<Typography variant="body2">{value}</Typography>
									) : (
										value
									)}
								</Grid>
							</Grid>
						</Box>
					</Grid>
				);
			})}
		</Grid>
	);
};
